var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144-413h360v556h-360z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.081 4.044a.469.469 0 0 1 .014.648l-.014.014-4.826 4.825h12.62c.259 0 .469.224.469.5 0 .27-.2.49-.451.5H4.319l4.762 4.763a.469.469 0 0 1 .014.648l-.014.014a.469.469 0 0 1-.648.014l-.014-.014L2.96 10.5a.5.5 0 0 1-.305-.469v-.012a.467.467 0 0 1 .124-.336l5.639-5.64a.469.469 0 0 1 .662 0Z",
    fill: "#000"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.10840cff.svg";
export { ForwardRef as ReactComponent };